<script>
import { Base as BaseApi } from 'firepuma-vue-axios-vuex-extensions/axios-utils/apiBase';
import { BexFormWithValidation as FormWithValidation } from 'bootstrap-vue-extensions';
import InlineAlerts from 'firepuma-vue-axios-vuex-extensions/vuex-errors/components/InlineAlerts.vue';

export default {
  components: {
    FormWithValidation,
    InlineAlerts,
  },

  props: {
    method: { type: String, required: true },
    url: { type: String, required: true },
    payload: { type: Object, default: () => ({}) },
    makeSuccessMessage: { type: Function },
  },

  data: () => ({
    result: undefined,
    busy: false,
    error: undefined,

    inlineAlerts: [],

    resetFormPristineTrigger: 0,
  }),

  computed: {
    scopedSlotKeysExcludingDefault() { return Object.keys(this.$scopedSlots).filter(x => x !== 'default') },
  },

  methods: {
    async onSubmit() {
      this.error = undefined;
      this.busy = true;
      try {
        let base = new BaseApi();
        let api = base.api();

        let result = await api.request({ method: this.method, url: this.url, data: this.payload });
        result = await base.handleResponse(result);

        if (this.makeSuccessMessage) {
          // Do this before $emit below so that the component using ActionForm uses "values before clearForm() is called"
          let successText = this.makeSuccessMessage(result);
          this.inlineAlerts.push({ text: successText, variant: 'success' });
        }

        this.$emit('success', result);
        this.result = result;

        this.resetFormPristineTrigger++;
      } catch (err) {
        if (err instanceof Error && err.is_warnings) {
          this.$emit('warnings', err.warnings);
        } else if (err instanceof Error && err.is_warning) {
          this.$emit('warnings', [err.message]);
        } else {
          this.$emit('error', err);
          this.error = String(err);
        }
      } finally {
        this.busy = false;
      }
    },

    onCancel() {
      this.resetFormPristineTrigger++;
      this.$emit('cancel');
    },
  },
}
</script>

<template>
  <form-with-validation
    v-bind="$attrs"
    v-on="$listeners"
    :reset-pristine-trigger="resetFormPristineTrigger"
    :busy-submitting="busy"
    @submit="onSubmit"
    @cancel="onCancel">

    <inline-alerts v-model="inlineAlerts" alert-css-classes="mt-2" />

    <!--  Since vue 2.6  -->
    <template v-for="slot of scopedSlotKeysExcludingDefault" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>

    <slot :busy="busy" :error="error" :result="result"></slot>

    <b-alert v-if="error" variant="danger" show dismissible>{{error}}</b-alert>

  </form-with-validation>
</template>



// WEBPACK FOOTER //
// src/AxiosApiForm.vue